import api from './api';

const quoteService = {
  async getQuote({ locationId, programId, coursesIds, studentId, orderId, coupon, rut }) {
    let url = `/quote?locationId=${locationId}&programId=${programId}&coursesIds=${coursesIds}&studentId=${studentId}&orderId=${orderId}&coupon=${coupon || ''}`;
    if (coupon && rut) url += `&rut=${encodeURIComponent(rut)}`;
    const { data } = await api.get(url);
    return data;
  }
};

export default quoteService; 